import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { fetchFunFacts, pick } from "@/lib/insights";

const UNITS = { 18: ["₹", true], 19: ["₹", true], 20: ["₹", false], 21: ["₹", true], 24: ["+₹", true] };

export function factHeadline(f, lang, t) {
  if (typeof f.headline === "number") {
    const [pre, cr] = UNITS[f.n] || ["", false];
    return `${pre}${f.headline.toLocaleString("en-IN")}${cr ? ` ${t("cr")}` : ""}`;
  }
  return pick(f, "headline", lang) || f.headline;
}

// Scrolling strip of Assembly fun facts shown under the header on every page
export default function FunFactsTicker() {
  const { t, lang } = useLang();
  const ta = lang === "ta";
  const [facts, setFacts] = useState([]);
  const { pathname } = useLocation();
  const toFacts = () => { if (pathname === "/changes") document.getElementById("facts")?.scrollIntoView({ behavior: "smooth" }); };
  useEffect(() => { fetchFunFacts().then((d) => setFacts(d.facts)).catch(() => {}); }, []);
  if (!facts.length) return null;
  const chars = facts.reduce((a, f) => a + String(pick(f, "fact", lang)).length + String(pick(f, "detail", lang)).length + 12, 0);
  const row = facts.map((f) => (
    <Link key={f.n} to="/changes#facts" onClick={toFacts} className={`shrink-0 inline-flex items-baseline gap-2 px-5 text-[13px] text-[#1a1640] hover:underline ${ta ? "font-tamil" : ""}`} data-testid={`ticker-fact-${f.n}`}>
      <span className="rounded-md bg-[#1a1640] text-white px-1.5 py-0.5 font-bold tabular-nums whitespace-nowrap">{factHeadline(f, lang, t)}</span>
      <span className="font-bold whitespace-nowrap">{pick(f, "fact", lang)}:</span>
      <span className="whitespace-nowrap text-[#3d3a63]">{pick(f, "detail", lang)}</span>
      <span className="text-[#c9c2a8]">◆</span>
    </Link>
  ));
  return (
    <div className="relative flex items-center bg-[#fff6dd] border-b border-[#efe2b8] overflow-hidden" data-testid="fun-facts-ticker">
      <span className={`z-10 shrink-0 inline-flex items-center gap-1.5 bg-[#1a1640] text-white px-3 py-2 text-[11px] font-bold uppercase ${ta ? "font-tamil normal-case" : "tracking-[0.14em]"}`}>
        <Sparkles size={13} /> {t("facts_title")}
      </span>
      <div className="flex-1 overflow-hidden py-2">
        <div className="flex w-max fact-ticker-track" style={{ animationDuration: `${Math.round(chars * 0.11)}s` }}>{row}{row}</div>
      </div>
    </div>
  );
}
